module.exports = __webpack_public_path__ + "static/img/player_head_10.d1e6df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_10.jpg
// module id = Dua0
// module chunks = 1